import styled from "styled-components";

export const Step3ScheduleReserveContainerStyled = styled.div`
  padding: 20px 20px 46px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .step_schedule_reserve_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .header_layout {
      margin-bottom: 32px;
    }
    .header_backhome_layout {
      margin-bottom: 32px;
    }
    .title_preview {
      margin-bottom: 28px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .btn_confirm_wrap {
      margin: auto;
      margin-top: 20px;
      max-width: 294px;
    }
    .detail_layout {
      margin-bottom: 28px;
    }
    .button_layout {
      padding: 0 42px;
      display: flex;
      justify-content: center;
      column-gap: 36px;
      .button1 {
        flex: 1;
      }
      .button2 {
        flex: 1;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: ${({ isPreview }) =>
      isPreview ? "0px 20px 30px 20px" : "46px 20px"};
    .breadcrumb_layout {
      display: none;
    }
    .step_schedule_reserve_container {
      .button_layout {
        padding: 0;
        display: flex;
        column-gap: 16px;
      }
    }
  }
`;
